<div class="timeinputcontainer">
  <input
    class="uk-input"
    type="number"
    min="0"
    [(ngModel)]="metricvalue"
    [name]="inputName"
    (ngModelChange)="updateMetricValue($event)"
  >
  <span class="timeFormat">{{ hours }}:{{ minutes }}:{{ seconds }}</span>
</div>
